import client from '../client'

export const getMyVehiclesKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Search/GetMyVehicles`

export async function getMyVehicles() {
  return client(getMyVehiclesKey)
}
